import * as yup from "yup";

export const guestSchema = yup.object().shape({
  guestName: yup.string().required("Guest Name Is Required"),
  guestDescription: yup.string(),
  guestPodcast: yup.string(),
  guestContactNum: yup.string(),
  guestEmailId: yup.string(),
  guestInstaProfile: yup.string(),
  guestIntrested: yup.string(),
  guestBusinessName: yup.string(),
});
